import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button, ButtonToolbar, Modal } from "reactstrap";
import { CircularProgress } from "@material-ui/core";
import classNames from "classnames";

const ModalComponent = ({
  color,
  title,
  message,
  colored,
  header,
  buttonOkName = "Ok",
  handleOkClick,
  toggle,
  isSuggestion = false,
  isDeleting,
}) => {
  let Icon;

  switch (color) {
    case "primary":
      Icon = <span className="lnr lnr-pushpin modal__title-icon" />;
      break;
    case "success":
      Icon = <span className="lnr lnr-thumbs-up modal__title-icon" />;
      break;
    case "warning":
      Icon = <span className="lnr lnr-flag modal__title-icon" />;
      break;
    case "danger":
      Icon = <span className="lnr lnr-cross-circle modal__title-icon" />;
      break;
    default:
      break;
  }
  const modalClass = classNames({
    "modal-dialog--colored": colored,
    "modal-dialog--header": header,
  });

  return (
    <div>
      <Modal
        isOpen={true}
        toggle={toggle}
        className={`modal-dialog--${color} ${modalClass}`}
        centered
      >
        <div className="modal__header">
          <button
            className="lnr lnr-cross modal__close-btn"
            aria-label="modal__close-btn"
            type="button"
            onClick={toggle}
          />
          {header ? "" : Icon}
          <h4 className="text-modal  modal__title">{title}</h4>
        </div>
        <div className="modal__body">{message}</div>
        {!isSuggestion && (
          <ButtonToolbar className="modal__footer">
            <Button className="modal_cancel" onClick={toggle}>
              Cancel
            </Button>{" "}
            <Button
              className="modal_ok"
              disabled={isDeleting}
              outline={colored}
              color={color}
              onClick={handleOkClick}
            >
              {isDeleting && <CircularProgress color="inherit" size={15} />} {buttonOkName}
            </Button>
          </ButtonToolbar>
        )}
        <ButtonToolbar className="modal__footer">
          {
            isSuggestion && handleOkClick && <Button
              className="modal_ok"
              outline={colored}
              color={color}
              onClick={handleOkClick}
            >
              {buttonOkName}
            </Button>
          }
        </ButtonToolbar>
      </Modal>
    </div>
  );
};

ModalComponent.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  color: PropTypes.string.isRequired,
  colored: PropTypes.bool,
  header: PropTypes.bool,
  handleOkClick: PropTypes.func,
  toggle: PropTypes.func.isRequired,
  isDeleting: PropTypes.bool,
  isSuggestion: PropTypes.bool,
};

ModalComponent.defaultProps = {
  title: "",
  message: "",
  colored: false,
  header: false,
};

export default connect((state) => ({}))(ModalComponent);
